/** @file GLSL ES 3.00 sources of the one viewport shader: world→clip rows, page texel × premultiplied tint. */

/**
 * Attribute locations are fixed in the source (0 position, 1 page uv, 2 light RGBA8 normalized); the dark word
 * (RenderBuffers word 5) is unused in phase 1, as in raster. The light colour is straight and interpolated
 * straight, then premultiplied per fragment exactly like raster: out = texel × (r·a, g·a, b·a, a) (§7.3).
 */
export const SHADER_SOURCE = {
  vertex: `#version 300 es
layout(location = 0) in vec2 aPos;
layout(location = 1) in vec2 aUv;
layout(location = 2) in vec4 aLight;
uniform vec3 uRow0;
uniform vec3 uRow1;
out vec2 vUv;
out vec4 vLight;
void main() {
  vec3 p = vec3(aPos, 1.0);
  vUv = aUv;
  vLight = aLight;
  gl_Position = vec4(dot(uRow0, p), dot(uRow1, p), 0.0, 1.0);
}
`,
  fragment: `#version 300 es
precision highp float;
uniform highp sampler2D uPage;
in vec2 vUv;
in vec4 vLight;
out vec4 outColor;
void main() {
  outColor = texture(uPage, vUv) * vec4(vLight.rgb * vLight.a, vLight.a);
}
`,
} as const;
